import { Carousel, useCarouselController } from 'components/carousel'
import { css, useTheme } from '@fable/theme'
import { CMSValueProp } from 'types'
import { FlexBox, Logo, Text } from '@fable/components'
import { BookDetailValueProp } from './BookDetailValueProp'
import { BookDetailValuePropsControls } from './BookDetailValuePropsControls'
import { VALUE_PROP_LIST } from 'queries'
import { useQuery } from '@apollo/client'
import { BookDetailDownloadAppCTA } from '../BookDetailDownloadAppCTA'
import { Book } from '@fable/types'

interface Props {
  book: Book
}

export const BookDetailValuePropsV2 = ({ book }: Props) => {
  const { breakpoints, mediaQueries, colors } = useTheme()
  const carouselController = useCarouselController()

  const { data, loading, error } = useQuery(VALUE_PROP_LIST, {
    variables: { id: '15WOg5kbTjer9PywIN5TZS' },
  })

  if (loading)
    return (
      <FlexBox centerAll>
        <Logo animate isIcon />
      </FlexBox>
    )

  if (!data || !!error) return null

  const valuePropsData = data?.valuePropList
  const valuePropItems = valuePropsData?.listCollection?.items as CMSValueProp[]
  const valueProps = valuePropItems || []

  return (
    <div
      className={css`
        position: relative;
        ${mediaQueries.tabletL} {
          margin-top: 32px;
        }
      `}
    >
      <div
        className={css`
          display: none;
          ${mediaQueries.mobileL} {
            display: revert;
          }
        `}
      >
        <FlexBox
          className={css`
            margin-bottom: 16px;
          `}
          justifyContent="space-between"
          alignItems="center"
        >
          <Text tag="h2" type="header" sizing="XS" color={colors.uiGraphite}>
            {valuePropsData?.title}
          </Text>
          <BookDetailValuePropsControls controller={carouselController} />
        </FlexBox>
        <Carousel
          controller={carouselController}
          options={{
            slides: { perView: 'auto', spacing: 12, origin: 0 },
          }}
          childWidths={[
            { width: '85%', breakpoint: 'base' },
            { width: '332px', breakpoint: breakpoints.mobileL },
          ]}
          noOverflow
        >
          {valueProps?.map((item, i) => (
            <BookDetailValueProp
              key={i}
              hide={i < carouselController.currentSlide}
              {...item}
            />
          ))}
        </Carousel>
      </div>
      <FlexBox
        className={css`
          ${mediaQueries.mobileL} {
            display: none;
          }
        `}
        flexDirection="column"
        alignItems="stretch"
        gap="16px"
      >
        {valueProps?.map((item, i) => (
          <BookDetailValueProp key={i} row {...item} />
        ))}
      </FlexBox>
      <BookDetailDownloadAppCTA
        className={css`
          margin-top: 16px;
          width: 100%;
          ${mediaQueries.tabletL} {
            width: 232px;
          }
        `}
        options={{
          eventMetadata: {
            book_id: book?.id,
          },
        }}
      />
    </div>
  )
}
